export const getSEOLink = (page: number, link?: string): string => {
    if (!link) {
        return '#';
    }

    if (page === 1) {
        return link;
    }

    return `${link}?page=${page}`;
};

export default null;
